<template>
  <div class="fish">
    <div class="fish-container">
      <div :id="`fish-${color}`"></div>
      <div class="bubble-container">
        <div :id="`bubble-${color}`"></div>
        <div v-show="!activeFeedback" class="bubble-text">{{ answer }}</div>
        <div :class="{ 'feedback-container': true, 'feedback-animation': activeFeedback }">
          <img
            v-show="this.$store.state.fishyProblems.correctStatus"
            src="@/assets/practices/fishy_problems/feedback_correct.svg"
            alt="correct"
          />
          <img
            v-show="!this.$store.state.fishyProblems.correctStatus"
            src="@/assets/practices/fishy_problems/feedback_incorrect.svg"
            alt="incorrect"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import lottie from 'lottie-web/build/player/lottie';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'Fish',
  props: {
    color: { type: String, default: '' },
    answer: { type: String, default: '???' },
  },
  computed: {
    ...mapGetters({
      answerStatus: 'fishyProblems/answerStatus',
    }),
    activeFeedback: function () {
      return this.answerStatus;
    },
  },
  mounted() {
    lottie.loadAnimation({
      container: document.getElementById(`fish-${this.color}`),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: `/assets/practices/fishy_problems/animations/fish_${this.color}.json`,
    });
    lottie.loadAnimation({
      container: document.getElementById(`bubble-${this.color}`),
      renderer: 'svg',
      loop: false,
      autoplay: true,
      path: `/assets/practices/fishy_problems/animations/bubble.json`,
    });
    sounds.fishyProblemsBubble.play();
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.fish {
  height: 50vh;
  position: absolute;
  transform: translate(0, 15vh);
  width: 50vh;

  &-container {
    @include flex-center;
    height: 100%;
    position: relative;
    width: 100%;

    #fish-orange,
    #fish-purple,
    #fish-red {
      animation: float-fish 2.5s infinite;
      height: 70%;
      position: absolute;
      transform: translate(-50%, 0);
      width: 100%;
    }

    .bubble-container {
      @include flex-center;
      animation: float-bubble 5s infinite;
      height: 80%;
      position: absolute;
      transform: translate(50%, -5%);
      width: 80%;

      #bubble-orange,
      #bubble-purple,
      #bubble-red {
        height: 100%;
        width: 100%;
      }

      .bubble-text {
        animation: fade-in 2.25s 2s forwards;
        position: absolute;
        opacity: 0;
        text-align: center;
        width: 85%;
      }

      .feedback-container {
        @include flex-center;
        height: 100%;
        opacity: 0;
        position: absolute;
        width: 100%;

        img {
          height: 70%;
          position: absolute;
          width: 70%;
        }
      }

      .feedback-animation {
        animation: scale-in 2s forwards;
        opacity: 1;
      }
    }
  }
}

@keyframes float-bubble {
  0% {
    transform: translate(50%, -5%);
  }
  50% {
    transform: translate(50%, -7.5%);
  }
  100% {
    transform: translate(50%, -5%);
  }
}

@keyframes float-fish {
  0% {
    transform: translate(-50%, 0%);
  }
  50% {
    transform: translate(-50%, -2.5%);
  }
  100% {
    transform: translate(-50%, 0%);
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
    transform-origin: left;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform-origin: left;
    transform: scale(1);
  }
}

@keyframes scale-in {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

@media (max-aspect-ratio: 8/5) {
  .fish {
    height: 35vh;
    width: 35vh;

    .bubble-container {
      .bubble-text {
        font-size: 0.8em;
      }
    }
  }
}
</style>
